<template>
  <div class="top-wrapper">
    <div class="top-nav">
      <img :src="headerLogo" alt="" />
      <div style="margin-left: 337px">
        <span @click="goUrl('http://121.40.212.122:83', true)">登录</span> <!--112.124.13.57-->
<!--        <span @click="goUrl('http://localhost:83', true)">登录</span> &lt;!&ndash;112.124.13.57&ndash;&gt;-->
        |
        <span @click="centerDialogVisible = true">注册</span>
      </div>
    </div>
    <div class="header-bar">
      <div class="nav-bar">
        <ul>
          <li
            v-for="(item, index) in navBarList"
            :key="index"
            :class="[idx === index ? 'pitch-bar' : '']"
            @click="titClick(index, item.url)"
          >
            <span>{{ item.title }}</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- 企业注册弹框 -->
    <el-dialog
      title="企业注册"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
      @close="closeDialog('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="注册企业名称" prop="nickName">
          <el-input
            v-model.number.trim="ruleForm.nickName"
            placeholder="请输入注册企业名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="登录名" prop="userName">
          <el-input
            v-model.number.trim="ruleForm.userName"
            placeholder="请输入您的登录名"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model.trim="ruleForm.password"
            autocomplete="off"
            placeholder="请输入您的密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
            type="password"
            v-model.trim="ruleForm.checkPass"
            autocomplete="off"
            placeholder="请再次输入您的密码"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="DxpId" prop="dxpId">
          <el-input v-model="ruleForm.dxpId" placeholder="只能输入数字和字母" @keyup.native="ruleForm.dxpId=ruleForm.dxpId.replace('^[A-Za-z0-9]+$')"></el-input>
        </el-form-item> -->
        <el-form-item label="电商平台代码" prop="ebpCode">
          <el-input
            v-model.trim="ruleForm.ebpCode"
            placeholder="请输入电商平台代码"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="电商平台名称" prop="ebpName">
          <el-input
            v-model.trim="ruleForm.ebpName"
            placeholder="请输入电商平台名称"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="十位海关代码" prop="ebcCode">
          <el-input
            v-model.trim="ruleForm.ebcCode"
            placeholder="请输入十位海关代码"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phonenumber">
          <el-input
            v-model.trim="ruleForm.phonenumber"
            placeholder="请输入手机号码"
            maxlength="11"
          />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model.trim="ruleForm.email"
            placeholder="请输入邮箱"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { Message } from "element-ui";
import headerLogo from "../../assets/images/header/logo.png";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      headerLogo: headerLogo,
      ruleForm: {
        checkPass: "", //验证密码
        password: undefined,
        userName: undefined,
        nickName: undefined,
        ebpName: undefined,
        ebpCode: undefined,
        ebcName: undefined,
        phonenumber: undefined,
        email: undefined,
        // dxpId: undefined,
        sex: "0",
        status: "0",
        remark: undefined,
        postIds: [2],
        roleIds: [2]
      },
      rules: {
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        password: [
          {
            required: true,
            trigger: "blur",
            min: 6,
            message: "密码最少需要6位数"
          },
          { validator: validatePass, trigger: "blur" }
        ],
        userName: [
          { required: true, message: "请输入您的登录名", trigger: "blur" },
          { min: 1, max: 20, message: "不可以以数字开头长度", trigger: "blur" }
        ],
        nickName: [
          {
            required: true,
            message: "请输入您的注册企业名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur"
          },
          {
            validator: function(rule, value, callback) {
              if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
                callback(new Error("请输入中文,不可以使用数字和字母"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        ebpCode: [
          { required: true, message: "请输入电商平台代码", trigger: "blur" },
          {
            required: true,
            trigger: "blur",
            max: 20,
            message: "最多不超过20位"
          }
          //   {
          //   validator: function(rule, value, callback) {
          //     if (/^[A-Za-z0-9]+$/.test(value) == false) {
          //       callback(new Error("不可以输入中文及其它特殊符号"));
          //     } else {
          //       //校验通过
          //       callback();
          //     }
          //   },
          //   trigger: "blur"
          // }
        ],
        ebpName: [
          { required: true, message: "请输入电商平台名称", trigger: "blur" },
          {
            required: true,
            trigger: "blur",
            max: 20,
            message: "最多不超过20位"
          }
        ],
        ebcCode: [
          { required: true, message: "请输入十位海关代码", trigger: "blur" },
          { min: 10, max: 10, message: "海关代码长度不正确", required: true },
          {
            validator: function(rule, value, callback) {
              if (/^[A-Za-z0-9]+$/.test(value) == false) {
                callback(new Error("不可以输入中文及其它特殊符号"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        // dxpId: [
        //     { required: true, message: '请输入dxpId', trigger: 'blur'},
        //     {required: true,trigger: 'blur',max:20,message:'最多不超过20位'},
        //     {
        //     validator: function(rule, value, callback) {
        //       if (/^[A-Za-z0-9]+$/.test(value) == false) {
        //         callback(new Error("不可以输入中文及其它特殊符号"));
        //       } else {
        //         //校验通过
        //         callback();
        //       }
        //     },
        //     trigger: "blur"
        //   }
        // ],
        email: [
          { required: true, message: "邮箱地址不能为空", trigger: "blur" },
          {
            type: "email",
            message: "'请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        phonenumber: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      },
      idx: 0,
      centerDialogVisible: false, //企业注册弹框默认值
      navBarList: [
        { title: "首页", url: "/sunShine" },
        { title: "商品展示", url: "/shopView" },
        { title: "企业展示", url: "/enterpriseView" },
        { title: "B2C出口", url: "/btoC" },
        { title: "B2B出口", url: "/btoB" },
        { title: "政策法规", url: "/policies" },
        { title: "关于我们", url: "/about" }
      ]
    };
  },
  methods: {
    titClick(index, url) {
      this.idx = index;
      // localStorage.setItem("flag", index);
      this.$router.push(url);
      document.documentElement.scrollTop = 0;

    },
    // 关闭注册用户模态框清空填写数据
    closeDialog(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.password = "";
      this.ruleForm.userName = "";
      this.ruleForm.nickName = "";
      this.ruleForm.phonenumber = "";
      this.ruleForm.email = "";
      this.ruleForm.ebpCode = "";
      this.ruleForm.ebpName = "";
      this.ruleForm.ebcCode = "";
      // this.ruleForm.dxpId='';
    },
    // 提交注册用户数据
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.centerDialogVisible = false;
          this.ruleForm.ebcName = this.ruleForm.nickName;
          axios
            .post("api/system/user/up", this.ruleForm)
            .then(function(response) {
              console.log(response);
              console.log(response.data.msg);
              if (response.data.msg == "操作成功") {
                Message({
                  type: "success",
                  message: "您的账号注册成功"
                });
              } else {
                Message({
                  type: "error",
                  message: "注册失败"
                });
              }
            });
        } else {
          console.log("提交数据失败!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    goUrl(url, isBlank = false) {
      if (isBlank) {
        window.open(url);
      } else {
        this.$router.push(url);
      }
    },
    changeRoute() {
      let path = "";
      if (this.$route.fullPath === "/") {
        path = "/sunShine";
      } else {
        path = "/" + this.$route.fullPath.split("/")[1];
      }
      const index = this.navBarList.findIndex(item => item.url === path);
      this.idx = index;
    }
  },
  watch: {
    $route() {
      this.changeRoute();
    }
  },
  created() {
    this.changeRoute();
  }
};
</script>
<style scoped>
.top-wrapper {
  width: 100vw;
  overflow: hidden;
}
.nav-bar {
  width: 100vw;
  background: #f1781c;
  color: #fff;
}

.nav-bar > ul {
  width: 100%;
  height: 80px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-bar > ul > li {
  height: 100%;
  line-height: 80px;
  width: 154px;
  text-align: center;
  margin: 0 42px;
  cursor: pointer;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  font-size: 22px;
}
.nav-bar > ul > li:hover{
  background: #df5000;

}
.pitch-bar {
  background: #df5000;
}
</style>



// WEBPACK FOOTER //
// src/components/common/top.vue